(function () {
  'use strict';
  // rf-product-row.js
  // Phase 1: No custom observers needed.
  // Dawn's assets/animations.js handles scroll-trigger animate--slide-in globally,
  // including shopify:section:load re-init.
  // This guard shell is the canonical pattern for Phase 2+ sections that add custom observers.
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      // Add section-specific observer re-init here in Phase 2+ if needed.
      void event;
    });
  }
})();
